<template>
  <div id="app_content" class="public">
    <div class="container" v-if="products.length > 0">
      <div class="row breadcrumbs">
        <div class="col-md-12">
          <breadcrumb :elemento="true"
              v-if="loaded && (products[0].cod_macrofamiglia === 'CIN' || products[0].cod_macrofamiglia === 'NAS')  "/>
        </div>
      </div>
      <div class="row titoli" v-if="loaded">
        <div class="col-md-5">
          <image-elm :elm="products[0]"/>
        </div>
        <div class="col-md-7" v-if="loaded">
          <div class="prod-titolo">
            <!--            {{ products[0].cod_categoria }}-{{ products[0].cod_colore }}-->
            <cod-element :elm="products[0]"/>
          </div>
          <div class="prod-categoria">
            {{ products[0].family.descrizione }}
          </div>
          <div v-if="products[0].category" class="prod-categoria">
            {{ products[0].category.descrizione }}
          </div>
          <!--          <div class="prod-download">-->
          <!--            <span>Download</span>-->
          <!--            <img :src="url('/media/icons/download.svg')" alt="download icon">-->
          <!--          </div>-->
        </div>
      </div>

      <div class="row varianti" v-if="loaded && datasheet">
        <div class="col-md-12 mt-4 mb-4 varianti">{{ trans.get('public.detail.variant') }}</div>
      </div>
      <div class="row container-tabella" v-if="loaded && datasheet">
        <datasheet-heading v-if="datasheet" :datasheet="datasheet"/>
        <div class="col-md-12 righe" v-for="(prod, index) in products">
          <product-detail-card
              :key="index"
              @tipo="makeIntestazione"
              :index="index"
              :codart="prod.cod_art"
              :annotation="prod.annotation[0]"/>
        </div>
      </div>


    </div>
    <div class="container no-prods" v-if="products.length === 0">
        <h1>{{ trans.get('public.detail.no-prod') }}</h1>
    </div>

    <div class="inner-section newsletter">
      <div class="section-container">
        <div class="my-content">
          <form_newsletter_new/>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import breadcrumb from "./components/breadcrumb";
import productDetailCard from "./components/product-detail-card";
import form_newsletter_new from "./../form-newsletter-new"
import CodElement from "../../article/cod-element";
import datasheetHeading from "./components/datasheetHeading";

export default {
  name: "product-view",
  components: {
    CodElement,
    breadcrumb,
    productDetailCard,
    form_newsletter_new,
    datasheetHeading
  },
  data() {
    return {
      products: null,
      loaded: false,
      tipo: null,
      datasheet: null,
    };
  },
  mounted() {
    this.getProducts();

  },
  methods: {
    checkDatasheet() {
      this.products.forEach((el) => {
        if (el.datasheet.length > 0) {
          this.datasheet = el.datasheet

        }
      })

    },
    makeIntestazione: function (tipo) {
      //console.log('tipo',tipo)
      this.tipo = tipo;
    },
    getProducts: function () {
      let pathname = window.location.pathname.split("/");
      // let macrofamily = pathname[pathname.length - 4];
      // let family = pathname[pathname.length - 3];
      // let category = pathname[pathname.length - 2];
      let cod_card = pathname[pathname.length - 1].replace('%20', ' ')
      let color = null
      let slug = null
      if (this.cat === 'uncat-col') {
        slug = pathname[pathname.length - 1];
      } else {
        color = pathname[pathname.length - 1];
      }
      //console.log(macrofamily, family, category, 'color',  color, 'cod', slug)
      console.log(cod_card)
      axios({
        method: "get",
        url: window.location.origin + "/catalog/api/productdetail",
        params: {
          cod_card: cod_card,
          category: (this.cat === 'uncat' || this.cat === 'uncat-col') ? '' : this.cat,
          color: (this.col && this.col === 'SC') ? '' : this.col,
          slug: (slug) ? slug : null,
        },
      })
          .then((res) => {
            console.log('res.data', res.data)
            if (res.data) {
              this.products = res.data;
              this.checkDatasheet()
              this.loaded = true;
              this.$store.commit("setBread", res.data[0])
              // this.$store.commit("setBread", {
              //   macro: {
              //     code: macrofamily,
              //     desc: this.products[0].macrofamily.descrizione,
              //   },
              //   family: {
              //     code: family,
              //     desc: this.products[0].family.descrizione,
              //   },
              //   catcolor: {
              //     code: (color === 'SC') ? category : family + category + " " + color,
              //     desc: (color === 'SC') ? category : family + category + " " + color,
              //   },
              // });
            }


          })
          .catch((err) => {
            console.log(err.response.data);
          })
    },
  },
};
</script>

<style lang="scss" scoped>
h1,
span,
div,
p {
  color: #ffffff;
}

$greenprod: #abc932;
#app_content.public {
  font-size: 1rem;
  @media (min-width: 1921px) {
    font-size: var(--font-size-large);
  }

  .inner-section {
    width: 100vw;

    &.newsletter {
      background-color: #0e0e0e;
      margin-top: auto;
    }

    .my-content > div {
      padding: 0 20px;
    }
  }

  //.col-custom {
  //  width: calc(100% / 12);
  //
  //  @media (max-width: 576px) {
  //
  //
  //    padding: 3px 5px;
  //  }
  //
  //}
  //
  //.col-custom7 {
  //  width: calc(100% / 7);
  //  @media (max-width: 576px) {
  //
  //
  //    padding-right: 10px;
  //  }
  //}

  background-color: var(--black-2);

  .container {
    max-width: 100%;
    margin: 0;
    padding: 200px 0;
    @media (max-width: 1200px) {
      padding: 80px 0;
    }
    @media (min-width: 1200px) {
      max-width: calc(100% - var(--public-menu-width));
      margin: 0 0 0 var(--public-menu-width);
      padding: 30px;
    }

    .prod-titolo {
      font-size: 48px;
      color: $greenprod;
    }

    .prod-categoria:last-child {
      margin-bottom: 55px;
    }

    .prod-download {
      display: flex;
      align-items: baseline;
      cursor: pointer;

      span {

        color: $greenprod;
        margin-right: 5px;
      }

      img {

        display: inline-block;
      }
    }

    .container-tabella {
      width: 100%;
      display: flex;
      max-width: 100%;
      flex-direction: column;

    }

    @media (max-width: 1500px) {
      .container-tabella {
        width: 1200px;
        overflow-x: scroll;
      }
      .row.intestazione {
        max-width: 1200px;
        width: 1200px;
        @media (max-width: 576px){
          max-width: 1921px;
          width: 1921px;
        }
      }
      .righe {
        width: 1200px;
        overflow-x: auto;
        min-width: 1200px;
        @media (max-width: 576px){
          min-width: 1921px;
          width: 1921px;
        }
      }

    }

    .intestazione {
      text-align: center;
      align-items: center;
      position: relative;

      margin: 0;

      .col-md-12 {
        display: flex;
        flex-wrap: nowrap;

      }


      //& > * {
      //  text-overflow: ellipsis;
      //  white-space: nowrap;
      //  overflow-x: hidden;
      //  padding: 0 1px;
      //  &:hover {
      //    text-overflow: unset;
      //    white-space: unset;
      //    overflow-x: unset;
      //    position: relative;
      //    font-size: 16px;
      //    color: var(--green);
      //    width: fit-content;
      //    background-color: var(--black-2);
      //  }
      //  @media (min-width: 576px) {
      //    text-overflow: unset;
      //    white-space: unset;
      //    overflow-x: unset;
      //    &:hover {
      //      position: initial;
      //      font-size: 10px;
      //      color: inherit;
      //      width: calc(100% / 8);
      //      background-color: transparent;
      //    }
      //  }
      //}

    }

    .tabella {
      margin-top: 33px;
      font-size: 10px;
      text-align: center;
      height: 100%;

      @media (max-width: 576px) {
        font-size: 12px;
        width: 100%;
      }
    }

    .varianti {
      margin: 80px 0 20px;
      font-size: 21px;


      @media (max-width: 576px) {
        margin-top: 0;
      }
    }

    .breadcrumbs, .titoli {
      max-width: 100%;
    }
    &.no-prods {
      min-height: 50vh;
      h1 {
        margin-top: 100px;
      }
    }
  }
}

</style>
